// react
import { MouseEvent } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// types
import { Invoice } from '../../../@types';
import { invoiceStatuses } from '../../../@types/unions';

// mui
import { Box, Button, Grid, Paper, Typography } from '@mui/material';

// ui
import { IconCircle } from '../../ui/IconCircle/IconCircle';

// utils
import { formatCurrency } from '../../../utils/currency';

// props
export type CardInvoiceProps = {
	invoice: Invoice;
	onClick: (invoice: Invoice, e: MouseEvent<HTMLButtonElement>) => void;
};

export const CardInvoice = ({ invoice, onClick }: CardInvoiceProps) => {
	// hooks
	const { t } = useTranslation();
	const status = invoice.status;
	const isEditable = status != null && invoiceStatuses.includes(status) && status !== 'APPROVED';

	return (
		<Paper>
			<Box
				sx={(theme) => {
					return {
						padding: theme.spacing(2),
					};
				}}>
				<Grid alignItems="center" container justifyContent="space-between" spacing={2}>
					<Grid item xs>
						<Grid alignItems="center" container spacing={1.5}>
							<Grid item>
								<IconCircle color="blue" size="md" type="invoice" />
							</Grid>
							<Grid item>
								<Button
									disabled={!isEditable}
									onClick={(e) => {
										if (isEditable) {
											onClick(invoice, e);
										}
									}}
									sx={{ p: 0, textTransform: 'none' }}
									variant="text">
									<Typography color="brand.blue.500" component="div" fontWeight={700} variant="h3">
										{invoice.num || t('na')}
									</Typography>
								</Button>
							</Grid>
						</Grid>
					</Grid>
					<Grid item xs="auto">
						<Grid container direction="column" spacing={0.5}>
							<Grid item sx={{ textAlign: 'right' }}>
								<Typography color="text.secondary" textAlign="right" variant="caption">
									{t('amount')}
								</Typography>
							</Grid>
							<Grid item sx={{ textAlign: 'right' }}>
								<Typography
									component="div"
									fontWeight={700}
									lineHeight={1}
									textAlign="right"
									variant="h3">
									{formatCurrency({
										currency: invoice.currency,
										value: invoice.amount + (invoice.tax ?? 0),
									})}
								</Typography>
							</Grid>
						</Grid>
					</Grid>
					<Grid item xs="auto">
						<Button
							disabled={!isEditable}
							onClick={(e) => {
								if (isEditable) {
									onClick(invoice, e);
								}
							}}
							size="small">
							<IconCircle color="primary" scheme="dark" type="edit" />
						</Button>
					</Grid>
				</Grid>
			</Box>
		</Paper>
	);
};
